import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { resendOtp } from "../Services/authService";

export const useResendOtp = () => {
  return useMutation({
    mutationFn: (resendData) => resendOtp(resendData),
    onSuccess: () => {
      toast.success("OTP resent successfully.");
    },
    onError: (err) => {
      toast.error(
        err?.response?.data?.message ?? "Failed to resend OTP", { toastId: "otpError" }
      );
    },
  });
};
